package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_08_18_Day_1
import com.veldekar.components.logs.Log_2023_08_18_Day_2
import com.veldekar.components.logs.Log_2023_08_18_Day_3
import com.veldekar.components.logs.Log_2023_08_18_Day_4
import com.veldekar.components.logs.Log_2023_08_18_Day_5
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-08-18")
@Composable
public fun Log_2023_08_18(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "The Green Dragon Sylus",
        ogTitle = "The Green Dragon Sylus",
        date = LocalDate(2_023, 8, 18),
        ogDescription = "Emerging from the caves, the heroes spot the green dragon Sylus and attempt to hide as they travel through his valley.",
        ogImage = "ai/2023-08-18.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-32", dateString = "Newgrowth 32")
        Log_2023_08_18_Day_1()
        SessionDayHeader(dayId = "newgrowth-33", dateString = "Newgrowth 33")
        Log_2023_08_18_Day_2()
        SessionDayHeader(dayId = "newgrowth-34", dateString = "Newgrowth 34")
        Log_2023_08_18_Day_3()
        SessionDayHeader(dayId = "newgrowth-35", dateString = "Newgrowth 35")
        Log_2023_08_18_Day_4()
        SessionDayHeader(dayId = "newgrowth-36", dateString = "Newgrowth 36")
        Log_2023_08_18_Day_5()
        SessionMediaItem(
            image = "images/drill_10percent_optimized.gif",
            linkImage = "images/drill_30percent_optimized.gif",
            description = "An animated LEGO scene featuring numerous figures on a blue baseplate representing water. The scene shows the type of work that Annette Dazzlecraft used to do a defense contractor. Inspecting cannons and siege weapons.",
            width = 302,
            height = 358,
        )
        SessionMediaItem(
            image = "images/farmTool_10percent_optimized.gif",
            linkImage = "images/farmTool_30percent_optimized.gif",
            description = "A high-quality animated LEGO farm scene with plants and figures. This is a depiction of an agricultural machine manufactured by Dazzlecraft and Tinkerrock.",
            width = 302,
            height = 243,
        )
        SessionMediaItem(
            image = "images/workshopHappy_10percent_optimized.gif",
            linkImage = "images/workshopHappy_30percent_optimized.gif",
            description = "A higher quality animated LEGO scene of a happy, busy workshop. This is Dazzlecraft and Tinkerrock's workshop before Tinkerrock was lynched by a mob.",
            width = 302,
            height = 246,
        )
        SessionMediaItem(
            image = "images/workshopSad_10percent_optimized.gif",
            linkImage = "images/workshopSad_30percent_optimized.gif",
            description = "A higher quality animated LEGO scene of the workshop taken over by spooky figures. This is Dazzlecraft and Tinkerrock's workshop; depicting a mob lynching Tinkerrock.",
            width = 302,
            height = 233,
        )
    }
}
